var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout',_vm._b({},'layout',{sidebar: _vm.sidebar},false),[_c(_vm.page,{ref:"page",tag:"component",on:{"sidebar":function($event){_vm.sidebar = $event}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }